import request from '@/util/request';
import qs from 'qs';

// 分页
export const getPageListApi = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/questionnairesurvey/page',
    Object.assign({}, options, { params })
  );

// 新增
export const addApi = (params, options) =>
  request.post('/api/v4ward/callcenter/questionnairesurvey/submit', params, options, {
    ContentType: 'application/json',
  });

// 修改
export const updateApi = (params, options) =>
  request.post('/api/v4ward/callcenter/questionnairesurvey/update', params, options, {
    ContentType: 'application/json',
  });

// 删除
export const delApi = (params, options) =>
  request.post('/api/v4ward/callcenter/questionnairesurvey/remove', qs.stringify(params), options);

// 发布|下架
export const switchStatusApi = (params, options) =>
  request.post('/api/v4ward/callcenter/questionnairesurvey/publishstatus', params, options, {
    ContentType: 'application/json',
  });
